import React  from 'react';
import NextButton from '../../components/nextButton';
import styled, { keyframes } from 'styled-components';
import { fadeInLeft } from 'react-animations';
import './style.css';

const FinikItog2 = styled.img`
	animation: 3s ${keyframes`${fadeInLeft}`} ;
  position: absolute;
  left: 10vw;
  top: auto;
  right: auto;
  bottom: 9vh;
  width: 200px;
	@media screen and (max-width: 991px) {
	  left: 6vw;
    width: 180px;
	}
	@media screen and (max-width: 767px) {
	  left: 20%;
    width: 155px;
  }
	@media screen and (max-width: 479px) {
    bottom: 10vh;
    width: 80px;
    left: 20px;
  }
`;

const PageWordsEnd = ({ onNextLevel, messNext, answer, setAnswer } ) => {
  return ( 
		<div className="section-info section-itog-block">
			<div className="content-front w-container">
				<div className="itext-box_itog">
					<div className="head-itog">Молодец!</div>
					<div className="text-block-front">Ты справился с первым заданием и познакомился с новыми словами. Но ключ найти мы не смогли.<br/>Давай искать дальше.<br/></div>
					<NextButton classes="button-q margin w-button" onNextLevel={onNextLevel} messNext="вперёд" />
					</div>
			</div>
			<FinikItog2 src="images/finik7.png" loading="lazy" alt="" className="finik-itog2"/>
		</div>
  );
}

export default PageWordsEnd;
